module.exports = __webpack_public_path__ + "img/bb_g3_t_ears-02.45433316.svg";